module.exports = __webpack_public_path__ + "static/scale-model-of-cedar-rapids-tourism-office-in-cedar-rapids-iowa-466563fab0d562f39b554c8df5607cb8.png";